import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SelectOption } from '../../sky-select/sky-select.component';

@Component({
  selector: 'sky-pagination-size[control]',
  template: `
    <sky-select
      class="w-full ml-auto"
      [label]="label"
      [clearable]="false"
      [control]="control"
      [options]="options"
      [smallSized]="smallSized"
    ></sky-select>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class PaginationSizeComponent<T> {
  @Input() public control!: FormControl;
  @Input() public options: Array<SelectOption<number>> = [
    {
      id: 10,
      label: '10 pozycji',
    },
    {
      id: 20,
      label: '20 pozycji',
    },
    {
      id: 50,
      label: '30 pozycji',
    },
    {
      id: 100,
      label: '100 pozycji',
    },
  ];
  @Input() public label = '';
  @Input() public smallSized = true;
}
